import api_energy_eye from "../../api/api_energy_eye.js";
import axios from "axios";
import { CSRF_TOKEN } from "../../common/csrf_token.js";

const state = {
    energyEyeDashboards: null,
    selectMenus: null,
    areaGraphData: null,
    barGraphData: null,
    distributionGraphData: null,
    statisticalData: null,
    secondaryAxis: false,
    yMax: null,
    sec_yMax: null,
    userEnergyEyeRecentQueries: null,
    relatedActions: null,
};


const getters = {
    getSelectMenus: state => state.selectMenus,
    getEnergyEyeDashboards: state => state.energyEyeDashboards,
    getAreaGraphData: state => state.areaGraphData,
    getBarGraphData: state => state.barGraphData,
    getDistributionGraphData: state => state.distributionGraphData,
    getStatisticalData: state => state.statisticalData,
    getSecondaryAxis: state => state.secondaryAxis,
    getYMax: state => state.yMax,
    getSecYMax: state => state.sec_yMax,
    getUserEnergyEyeRecentQueries: state => state.userEnergyEyeRecentQueries,
    getRelatedActions: state => state.relatedActions
};


const actions = {
  async fetchUserEnergyEyeRecentQueries({ commit }, payload) {
    commit("setLoader", true);
    const response = await api_energy_eye.userEnergyEyeRecentQueries(payload);
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
      commit("setLoader", false);
    }
    else {
      commit('setUserEnergyEyeRecentQueries', response.results.slice(0, 10));
      commit("setLoader", false);
    }
  },
  async performCreateEnergyEyeRecentQuery({commit}, payload) {
    const response = await api_energy_eye.energyEyeRecentQueryCreate(payload)
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    } else {
      if (response.error) {
        commit("setFormError", response.error);
      } else {
        console.log("Query saved to recent")
      }
    }
  },
  updateEnergyEyeCharts({dispatch}, payload) {
    dispatch ("performSetAreaGraphData", null);
    var new_area_data = {
        labels: payload.area_dataset.labels,
        time_labels: payload.area_dataset.time_labels,
        datasets: payload.area_dataset.datasets,
        ymax: payload.ymax,
        ymin: payload.ymin,
        sec_ymin: payload.sec_ymin,
        sec_ymax: payload.sec_ymax,
        chartInterval: payload.interval,
    };
    var new_bar_data = {
        labels: payload.bar_dataset.labels,
        time_labels: payload.bar_dataset.time_labels,
        datasets: payload.bar_dataset.datasets,
        ymax: payload.ymax,
        ymin: payload.ymin,
        sec_ymin: payload.sec_ymin,
        sec_ymax: payload.sec_ymax,
        chartInterval: payload.interval,
    };
    dispatch ("performSetAreaGraphData", new_area_data);
    dispatch ("performSetBarGraphData", new_bar_data);
  },
  async fetchEnergyEyeDashboards({ commit }) {
    const response = await api_energy_eye.energyEyeDashboards();
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    }
    else {
      commit('setEnergyEyeDashboards', response.queryset);
    }
  },
  async fetchSelectMenus({commit}, site_code) {
    commit("setLoader", true);
    const response = await api_energy_eye.energyEyeData(site_code);
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later")
      commit("setLoader", false);
    } else {
      commit("setSelectMenus", response);
      commit("setLoader", false);
    }
  },
  async performExecuteEnergyEyeQuery({commit, dispatch}, payload) {
    commit("setLoader", true);
    commit("setFormError", null);
    commit("setSecondaryAxis", false);
    commit("setRelatedActions", null);
    dispatch ("performSetAreaGraphData", null);
    dispatch ("performSetBarGraphData", null);
    dispatch ("performSetDistributionGraphData", null);
    const response = await api_energy_eye.executeEnergyEyeQuery(payload);
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later")
      commit("setLoader", false);
    } else {
       if (!response.error) {
          if (response.related_actions_queryset.length > 0) {
            commit("setRelatedActions", response.related_actions_queryset);
          }
          commit("setStatisticalData", response.statistical_data);
          var bar_dataset = response.bar_chart_data.meter_labels.map((bar_label, index) => ({
              label: bar_label,
              data: response.bar_chart_data.datasets[index],
              backgroundColor: response.bar_chart_data.colors[index],
              borderColor: response.bar_chart_data.colors[index],
              time_labels: response.bar_chart_data.time_labels[index],
              borderWidth: 1,
              fill: true,
          }));
          var area_dataset = response.area_chart_data.meter_labels.map((area_label, index) => ({
              label: area_label,
              data: response.area_chart_data.datasets[index],
              backgroundColor: response.area_chart_data.colors[index],
              borderColor: response.area_chart_data.colors[index],
              time_labels: response.area_chart_data.time_labels[index],
              borderWidth: 1,
              fill: true,
            }));
          var distribution_dataset = [
               {
                  label: '% Distribution', // Dataset label
                  data: response.distribution_chart_data.data, // Data values for each section of the doughnut
                  backgroundColor: response.distribution_chart_data.colors, // Colors for each section
                  borderColor: response.distribution_chart_data.colors, // Border colors for each section
                  borderWidth: 2 // Border thickness for the doughnut sections
               }
          ]
          if (response.bar_chart_data.secondary_meter_data.length > 0) {
            const isHourly = response.interval === "Hourly";
            const lineThickness = isHourly ? 1 : 2;
            const lineColor = isHourly ? "#191919" : "#000000";
            var secondary_meter =  {
                  label: response.bar_chart_data.secondary_meter_name,
                  data: response.bar_chart_data.secondary_meter_data, // Sample data for the line
                  type: 'line', // Explicitly set this as a line chart type
                  fill: false, // Don't fill the area under the line
                  borderColor: lineColor, // Set the line color to black
                  backgroundColor: "black", // Set point color to black
                  borderWidth: lineThickness,
                  pointRadius: 1, // Size of the data points
                  pointHoverRadius: 5, // Size of the points when hovered
                  yAxisID: 'y1',
                  stack: false,
            };
            bar_dataset.unshift(secondary_meter);
            area_dataset.unshift(secondary_meter);
            commit("setSecondaryAxis", true)
            // Remove elements with empty data arrays
            bar_dataset = bar_dataset.filter(dataset => dataset.data && dataset.data.length > 0);
            area_dataset = area_dataset.filter(dataset => dataset.data && dataset.data.length > 0);

          }
          var areaGraphData = {
              labels: response.area_chart_data.labels,
              time_labels: response.area_chart_data.time_labels,
              datasets: area_dataset,
              chartInterval: response.interval,
              chartUnits: response.units_string,
              secondaryChartUnits: response.secondary_units_string
          };
          var barGraphData = {
              labels: response.bar_chart_data.labels,
              time_labels: response.bar_chart_data.time_labels,
              datasets: bar_dataset,
              chartInterval: response.interval,
              chartUnits: response.units_string,
              secondaryChartUnits: response.secondary_units_string
          };
          var distributionGraphData = {
              labels: response.distribution_chart_data.labels,
              datasets: distribution_dataset,
              chartUnits: response.units_string,
              secondaryChartUnits: response.secondary_units_string
          };
          dispatch ("performSetAreaGraphData", areaGraphData);
          dispatch ("performSetBarGraphData", barGraphData);
          dispatch ("performSetDistributionGraphData", distributionGraphData);
          commit("setLoader", false);
          commit("setFormError", null);
       } else {
          commit("setLoader", false);
          commit("setFormError", response.error)
       }
    }
  },

  async performDownloadEnergyEyeCsvQuery({ commit }, payload) {
      try {
         commit("setLoader", true);
         commit("setFormError", null);

        // Make POST request to the Django endpoint for CSV download
        const response = await axios.post('/energy-eye/download-query-csv/', payload, {
          headers: {
            'X-CSRFToken': CSRF_TOKEN,
          },
          responseType: 'blob', // Expect binary data (CSV)
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: 'text/csv' });

        // Create a link element for download
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        // Set the download attribute to specify the filename
        link.download = `dataset.csv`;

        // Trigger the download by clicking the link
        link.click();

        commit("setLoader", false);

      } catch (error) {
        console.error('Error generating CSV:', error);
        commit("setLoader", false);
        commit("setFormError", "Submit a ticket with the following error message - " + error.message);

        // Hide the error message after 5 seconds
        setTimeout(() => {
          const errorElement = document.getElementById("formError");
          if (errorElement) {
            errorElement.style.display = "none";
          }
        }, 5000);
      }
    },

  async performDownloadEnergyEyeExcelQuery({ commit }, payload) {
      try {
         commit("setLoader", true);
         commit("setFormError", null);

        // Make POST request to the Django endpoint for CSV download
        const response = await axios.post('/energy-eye/download-query-excel/', payload, {
          headers: {
            'X-CSRFToken': CSRF_TOKEN,
          },
          responseType: 'blob', // Expect binary data (CSV)
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a link element for download
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        // Set the download attribute to specify the filename
        link.download = `dataset.xlsx`;

        // Trigger the download by clicking the link
        link.click();

        commit("setLoader", false);

      } catch (error) {
        console.error('Error generating Excel:', error);
        commit("setLoader", false);
        commit("setFormError", "Submit a ticket with the following error message - " + error.message);

        // Hide the error message after 5 seconds
        setTimeout(() => {
          const errorElement = document.getElementById("formError");
          if (errorElement) {
            errorElement.style.display = "none";
          }
        }, 5000);
      }
    },

  performSetAreaGraphData({commit}, data) {
    commit("setAreaGraphData", data)
  },
  performSetBarGraphData({commit}, data) {
    commit("setBarGraphData", data)
  },
  performSetDistributionGraphData({commit}, data) {
    commit("setDistributionGraphData", data)
  },
};

const mutations = {
  setUserEnergyEyeRecentQueries: (state, userEnergyEyeRecentQueries) => {
    state.userEnergyEyeRecentQueries = userEnergyEyeRecentQueries
  },
  setEnergyEyeDashboards: (state, energyEyeDashboards) => {
    state.energyEyeDashboards = energyEyeDashboards
  },
  setSelectMenus: (state, selectMenus) => {
    state.selectMenus = selectMenus
  },
  setAreaGraphData: (state, areaGraphData) => {
     state.areaGraphData = areaGraphData
  },
  setBarGraphData: (state, barGraphData) => {
     state.barGraphData = barGraphData
  },
  setDistributionGraphData: (state, distributionGraphData) => {
     state.distributionGraphData = distributionGraphData
  },
  setStatisticalData: (state, statisticalData) => {
     state.statisticalData = statisticalData
  },
  setSecondaryAxis: (state, secondaryAxis) => {
     state.secondaryAxis = secondaryAxis
  },
  setYMax: (state, yMax) => {
     state.yMax = yMax
  },
  setSecYMax: (state, sec_yMax) => {
     state.sec_yMax = sec_yMax
  },
  setRelatedActions: (state, relatedActions) => {
    state.relatedActions = relatedActions
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}